import { Page, PageTitle, PageTitleWrapper } from '../../../components';
import { StaffReassignmentList } from './staff-reassignment-list';

export const StaffReassignment = () => {
  return (
    <Page title="Staff Reassignment">
      <PageTitleWrapper>
        <PageTitle title="Staff Reassignment" />
      </PageTitleWrapper>
      <StaffReassignmentList />
    </Page>
  );
};
